var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"logo-alerta-hidrica",attrs:{"href":"https://alertahidrica.com/"}},[_c('img',{staticClass:"logo-alerta-hidrica--img",attrs:{"src":"img/logo_alertahidrica.png","alt":"Logo Alerta Hídrica"}})])
}]

export { render, staticRenderFns }